module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAAAXNSR0IArs4c6QAAAOhJREFUaEPtlkEOg0AMA+EHeXKfnB+04lwhudLWXoXhHK2xx4Q9j4c958P8HhieThzCEB6WAJUeBvTLDoQhPCwBKj0MKEuLSlPpYQlQ6WFA2dJU+q7SVfXaue7dLb2fTLiq3psblrxIQ5dRDG+Gu7sleNLQUwlLSyEFfvnSShlZrStXerVw6jwMp5J36cqEuWm5kIg6/Idvgvql0tylxbZZxv5RaW5aFnSLReRveLFu7DgMx6I3CUPYFHRMBsKx6E3CEDYFHZOBcCx6kzCETUHHZCAci94kDGFT0DEZCMeiNwlD2BR0TOYDJacwPZuY1lsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ico_equal.png
// module id = 7bWr
// module chunks = 1